import { Alignment } from '../../alignment';
import { WidgetType } from './widgetType';
export const ImageWidgetHelper = {
    isImageWidget: (widget) => {
        return widget.value.type === WidgetType.image;
    },
    makeDefaultProperties: () => ({
        alignment: Alignment.center,
        width: 100,
        caption: '',
        roundCorners: 0,
        displayDelayInSeconds: 0,
    }),
};
